/**
 * Every user-facing string on the launcher. Kept as data so the vocabulary
 * guard (pages/about/vocabulary.test.ts) can check it: no "governed", "remote",
 * "federation", "gateway", "SDK" or "Claude" (ADR 0028).
 */
export const LAUNCHER_COPY = {
  documentTitle: 'Growth Platforms App Store',
  eyebrow: 'Growth Platforms App Store · Powered by the AI Spine',
  lede: 'Every Growth Platforms app in one place, with shared sign-in, built-in AI and trusted data.',
  searchLabel: 'Find an app or tool',
  searchPlaceholder: 'Find an app or tool…',
  clearInput: 'Clear search text',
  aboutCta: 'What is the AI Spine? →',
  gridKicker: 'Your apps',
  gridTitle: 'Open an app',
  loading: 'Loading apps',
  matchOne: '1 app matches',
  /** Follows the count: "3 apps match". */
  matchMany: 'apps match',
  filterGroupLabel: 'Filter by category',
  allChip: 'All',
  /** Chip and announcement counts: "1 app", "3 apps". */
  appOne: 'app',
  appMany: 'apps',
  /** Joins a count or no-match message to a category: "… in Insights & reporting". */
  inCategory: 'in',
  /** No-match message when no search is active but a chip is: "No apps in …". */
  noAppsPrefix: 'No apps',
  emptyTitle: 'No apps are available to you yet.',
  emptyBody: 'Apps appear here once they are switched on for you.',
  emptyBuild: 'Build an app',
  emptyAccess: 'Request access',
  errorTitle: "We couldn't load your apps right now.",
  // Read aloud too, as one sentence pair, so sighted and screen-reader users get
  // the same instruction (Launcher's appsAnnouncement joins title and body).
  errorBody: 'Select Retry to try again.',
  retry: 'Retry',
  noMatchPrefix: 'No apps match',
  clearSearch: 'Clear search',
  toolsNote: 'These open in a new tab and use their own sign-in.',
  /** Appended to the live region while searching: "… 2 tools match." */
  toolsMatchOne: '1 tool matches.',
  /** Follows the count: "3 tools match." */
  toolsMatchMany: 'tools match.',
  toolsMatchNone: 'No tools match.',
  /** The tablist's accessible name, and its three tabs. */
  tabsLabel: 'Launcher sections',
  appsTab: 'Apps',
  toolsTab: 'Growth Platforms Tools',
  allMbrsTab: 'All MBRs',
  /** Shown inside a tools tab when a search clears its group out. */
  toolsGroupEmpty: 'No tools match your search.',
  /** Right-hand quick-launch dock in the hero band. */
  dockLabel: 'Quick launch your most used apps and tools',
  dockKicker: 'Quick launch your most used apps and tools',
  dockEmpty:
    'Open any app or tool in the Apps, Growth Platforms Tools, or All MBRs tabs below — your top 3 most used will appear here.',
  /** Read by screen readers after a dock entry that opens a new tab (the ↗ is decoration). */
  dockNewTab: 'opens in new tab',
  /** Trailing in-grid callout tile at the end of the apps grid. */
  nextTileKicker: 'Your app next',
  nextTileTitle: 'Ship your app next',
  nextTileBody: 'Plug into shared sign-in, built-in AI and trusted data on the AI Spine.',
  nextTileCta: 'Start onboarding',
  stripKicker: 'Build on the Spine',
  stripTitle: 'Have an idea for an app? Ship it on the App Store.',
  stripPrimary: 'Start building',
  stripSecondary: 'Talk to GP Technology',
} as const;
